export const patternDecimal = '[0-9]*[.,]?[0-9]*';
export const integersPattern = '[0-9]*';

export const getDecimalFormat = (number) => {
  return number ? number.toLocaleString("en-US") : "0.00";
};
export const getDecimals = (number, decimals) => {
  return number && number.toFixed(decimals);
};

export const formatNumber = (input, symbol = "", symbolPosition = false) => {
  try {
    let numericValue;
    let decimalsToUse = 2;

    if (
      typeof input === "object" &&
      input !== null &&
      input?.input !== undefined
    ) {
      const cleanedValue = String(input.input)
        .replace(/,/g, "")
        .replace(/[^\d.-]/g, "")
        .replace(/(\..*)\./g, "$1");
      numericValue = parseFloat(cleanedValue);
      decimalsToUse = input?.decimals ?? 2;
    } else if (
      typeof input === "number" ||
      (typeof input === "string" && !isNaN(Number(input)))
    ) {
      numericValue = Number(input);
    } else {
      numericValue = NaN;
    }

    if (isNaN(numericValue)) {
      const fallbackDecimals =
        typeof input === "object" && input !== null ? input?.decimals ?? 2 : 2;
      return `${symbolPosition ? symbol : ""} ${Number(0).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: fallbackDecimals,
          maximumFractionDigits: fallbackDecimals,
        }
      )} ${!symbolPosition ? symbol : ""}`.trim();
    }

    const factor = Math.pow(10, decimalsToUse);
    numericValue = Math.round(numericValue * factor) / factor;

    const formattedValue = numericValue.toLocaleString("en-US", {
      minimumFractionDigits: decimalsToUse,
      maximumFractionDigits: decimalsToUse,
    });

    return `${symbolPosition ? symbol : ""} ${formattedValue} ${
      !symbolPosition ? symbol : ""
    }`.trim();
  } catch (error) {
    if (typeof input === "object" && input?.forceZero) {
      const decimals = input?.decimals || 2;
      return `${symbolPosition ? symbol : ""} ${Number(0).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        }
      )} ${!symbolPosition ? symbol : ""}`.trim();
    }
    return `Error: ${error.message || "Unknown formatting error"}`.trim();
  }
};

export const handleDecimalInput = (input, currentValue) => {
  const regex = /^\d*[.,]?\d*$/;

  if (regex.test(input)) {
    return input;
  }
  return currentValue;
};
